import { SvelteMap } from "svelte/reactivity";

// The agent DM's forward window (server: agent-timeline-forward-page.ts). An open whose unread
// span is past the budget holds a page from the read turn before New that stops short of the
// tail; `cursor` is where the next newer read continues. While a window is open the live
// stream's rows are not applied (they would land below a hole): the reader pages down to them,
// and the page that reaches the tail closes the window so live rows apply again.
interface NewerEdge {
  cursor: string;
  loading: boolean;
}

export class NewerWindows {
  readonly #edges = new SvelteMap<string, NewerEdge>();

  /** A forward page landed: newer rows follow from `cursor`. */
  open(agentId: string, cursor: string): void {
    this.#edges.set(agentId, { cursor, loading: false });
  }

  /** The window reached the tail (or the stream was replaced): live rows apply again. */
  close(agentId: string): void {
    this.#edges.delete(agentId);
  }

  has(agentId: string): boolean {
    return this.#edges.has(agentId);
  }

  cursorOf(agentId: string): string | null {
    return this.#edges.get(agentId)?.cursor ?? null; // null: the stream reaches the tail
  }

  isLoading(agentId: string): boolean {
    return this.#edges.get(agentId)?.loading === true;
  }

  setLoading(agentId: string, loading: boolean): void {
    const edge = this.#edges.get(agentId);
    if (edge) this.#edges.set(agentId, { ...edge, loading });
  }

  clearAll(): void {
    this.#edges.clear();
  }
}

export const newerWindows = new NewerWindows();
